import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { MenuServices } from '../../services';
import { MenuCreateDishSelectPage } from '../../menu-create/menu-create-dish-select/menu-create-dish-select';
import { MenuCreateTitlePage } from '../../menu-create/menu-create-title/menu-create-title';
import { MenuCreatePricenextrasPage } from '../../menu-create/menu-create-pricenextras/menu-create-pricenextras';
import { ConfigurationImagesPage } from '../../../configuration/configuration-images/configuration-images';

/**
 * Generated class for the MenuXxssPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-template-audi',
  templateUrl: 'menu-template-audi.html',
})
export class MenuTemplateAudiPage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public menuServices: MenuServices,
    public globals: Globals) {
  }

  onBack() {
    this.navCtrl.pop();
  }

  editSection(section, index, menu_uid) {
    this.navCtrl.push(MenuCreateDishSelectPage, {
      type: this.menuServices.menu_tmp.style,
      section: index,
      section_complete: this.menuServices.menu_tmp.sections,
      update: true,
      menu_uid: menu_uid,
      menu: this.menuServices.menu_tmp,
      new: false,
    });
  }

  edit(section, index) {
    this.menuServices.edit = true;
    this.menuServices.edit_section = section;
    this.menuServices.edit_index = index;
    this.menuServices.edit_dish_array = this.globals.objectToArray(this.menuServices.edit_section.dish);
    this.menuServices.edit_type = 'dish';
  }

  editHeader() {
    //
    this.menuServices.edit = true;
    this.menuServices.edit_type = 'header';
    //
    this.navCtrl.push(MenuCreateTitlePage, {
      type: this.menuServices.menu_tmp.style,
      update: true,
      menu_uid: this.menuServices.menu_tmp.UID,
      reference: this.menuServices.menu_tmp.reference,
      title_es: this.menuServices.menu_tmp.title_es,
      title_ca: this.menuServices.menu_tmp.title_ca,
      title_en: this.menuServices.menu_tmp.title_en,
      title_de: this.menuServices.menu_tmp.title_de,
      title_it: this.menuServices.menu_tmp.title_it,
      title_fr: this.menuServices.menu_tmp.title_fr,
      subtitle: this.menuServices.menu_tmp.subtitle_es,
    });
  }
  editFooter() {
    //
    this.menuServices.edit = true;
    this.menuServices.edit_type = 'footer';
    //
    this.navCtrl.push(MenuCreatePricenextrasPage, {
      update: true,
      menu_uid: this.menuServices.menu_tmp.UID,
      price: this.menuServices.menu_tmp.price,
      price_takeaway: this.menuServices.menu_tmp.price_takeaway,
      pan_vino_agua_si: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_si,
      pan_vino_agua_no: this.menuServices.menu_tmp.extras_footer.pan_vino_agua_no,
      refresco_si: this.menuServices.menu_tmp.extras_footer.refresco_si,
      refresco_no: this.menuServices.menu_tmp.extras_footer.refresco_no,
      cafe_si: this.menuServices.menu_tmp.extras_footer.cafe_si,
      cafe_no: this.menuServices.menu_tmp.extras_footer.cafe_no,
      extra_price: this.menuServices.menu_tmp.extra,
      footer: this.menuServices.menu_tmp.footer,
      type: this.menuServices.menu_tmp.style,
    });
  }

  uploadImage() {
    this.globals.side_menu_config_active = 'images';
    this.navCtrl.push(ConfigurationImagesPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-templates/menu-template-audi/menu-template-audi.ts